import { useMemo } from 'react';
import CombinedBlock from './blocks/CombinedBlock';
import ImageBlock from './blocks/ImageBlock';
import RichTextBlock from './blocks/RichTextBlock';
import Gallery from './Gallery';

const ContentRenderer = ({ content, location, title, gallery }) => {
  const skipIndexes = useMemo(() => new Set(), []);

  const firstImageBlock =
    location === 'page'
      ? content.find((block) => block.strapi_component === 'detail.content-image')
      : null;

  let galleryUsed = false; // control para no repetir la galería

  return (
    <section className="mb-20">
      <div className="container">
        {/* Imagen destacada al principio si estamos en "page" */}
        {firstImageBlock && <ImageBlock key={firstImageBlock.id} image={firstImageBlock.image} />}

        {content.map((block, index, blocks) => {
          if (skipIndexes.has(index)) return null;

          const prev = blocks[index - 1];
          const next = blocks[index + 1];

          // Saltar imagen ya mostrada al principio
          if (location === 'page' && block.id === firstImageBlock?.id) {
            return null;
          }

          // Bloque combinado (imagen + texto) solo si NO estamos en "page"
          if (
            location !== 'page' &&
            block.strapi_component === 'detail.content-image' &&
            prev?.strapi_component === 'detail.rich-text' &&
            next?.strapi_component === 'detail.rich-text'
          ) {
            skipIndexes.add(index + 1);
            return (
              <CombinedBlock
                key={block.id}
                image={block.image}
                text={next.richtext.data.richtext}
              />
            );
          }

          // RichText con galería a la derecha (solo en "page" y una vez)
          if (
            location === 'page' &&
            block.strapi_component === 'detail.rich-text' &&
            gallery?.length > 0 &&
            !galleryUsed
          ) {
            galleryUsed = true;
            return (
              <div
                key={block.id}
                className="flex flex-col-reverse md:flex-row items-start gap-12 md:gap-16 my-16 md:relative "
              >
                <div className="md:w-7/12 md:-mt-8">
                  <RichTextBlock text={block.richtext.data.richtext} />
                </div>
                <div className="md:w-5/12 md:sticky md:top-4 ">
                  <h3 className="mb-4 text-sm text-blue-400 ">
                    Algunas de nuestras instalaciones de{' '}
                    <strong className="uppercase text-slate-700 block font-extrabold text-xl">
                      {title
                        .toLowerCase()
                        .replace(/en madrid$/, '')
                        .trim()}
                    </strong>
                  </h3>
                  <Gallery images={gallery} />
                </div>
              </div>
            );
          }

          // RichText normal
          if (block.strapi_component === 'detail.rich-text') {
            return <RichTextBlock key={block.id} text={block.richtext.data.richtext} />;
          }

          // Imagen suelta (si no se ha usado como destacada)
          if (block.strapi_component === 'detail.content-image') {
            return <ImageBlock key={block.id} image={block.image} />;
          }

          return null;
        })}
      </div>
    </section>
  );
};

export default ContentRenderer;
